import './icon.scss';

import React from 'react';

import { IconProps } from '../../types/icons';

const ChildSeatIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} `;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      viewBox="0 0 24 24"
      version="1.1"
      className={classes}
      data-testid="child-seat-icon"
      onClick={onClick}
    >
      <path
        d="M20.1625 2.00012L17.2625 15.8126C16.8875 18.2876 14.7 20.1501 12.175 20.1501H2V22.0001H12.1625C15.65 22.0001 18.575 19.5126 19.125 16.0626L22 2.00012H20.1625Z"
        fill="#7E8A96"
      />
      <path
        d="M14.3374 17.4619H5.4374C4.2624 17.4619 3.2624 16.6494 3.0124 15.5119L1.02486 5.33693C0.949858 4.97443 1.02486 4.38686 1.52486 3.88681C2.52486 2.88685 4.0499 2.06193 5.4999 5.33693C5.4999 5.33693 6.8624 7.62444 5.4999 12.4244C5.4999 12.4244 4.8124 14.9619 8.4124 14.3119C8.4124 14.3119 13.8749 12.0869 14.7249 17.0119C14.7624 17.2494 14.5749 17.4619 14.3374 17.4619Z"
        fill="#7E8A96"
      />
      <path
        d="M12.8124 18.1619H5.93743C5.76484 18.1619 5.62493 18.3019 5.62493 18.4744V19.0994C5.62493 19.272 5.76484 19.4119 5.93743 19.4119H12.8124C12.985 19.4119 13.1249 19.272 13.1249 19.0994V18.4744C13.1249 18.3019 12.985 18.1619 12.8124 18.1619Z"
        fill="#7E8A96"
      />
    </svg>
  );
};

export default ChildSeatIcon;
